import React from "react";
import { Link } from "react-router-dom";
import styles from "./ChopNationFooter.module.css";
import { FaFacebook, FaInstagram, FaTwitter } from "react-icons/fa";

const ChopNationFooter = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.brandSection}>
          <h2 className={styles.logo}>AURELIA<span>DINING</span></h2>
          <p>The finest dining experience delivered to your comfort zone by Aurelia Apartments. Fresh, fast, and delicious.</p>
          <div className={styles.socials}>
            <a href="#"><FaFacebook /></a>
            <a href="#"><FaInstagram /></a>
            <a href="#"><FaTwitter /></a>
          </div>
        </div>

        <div className={styles.linksSection}>
          <div>
            <h3>Explore</h3>
            <ul>
              <li><a href="#menu">Menu</a></li>
              <li><a href="#story">Our Story</a></li>
            </ul>
          </div>
          <div>
            <h3>Support</h3>
            <ul>
              <li><a href="#support">Contact Support</a></li>
              <li><Link to="/terms-of-service">Terms of Service</Link></li>
            </ul>
          </div>
        </div>
      </div>
      <div className={styles.bottom}>
        <p>&copy; 2025 Aurelia Apartments Dining. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default ChopNationFooter;
